import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { Button } from '@thd-olt-component-react/button';
import { track } from '../../analytics';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideShowCheckAvailability: false
    };
  }

  setStateAndProcessResponse = (response) => {
    const { onZipCodeChange } = this.props;
    if (response) {
      this.setState({
        hideShowCheckAvailability: false
      });
      onZipCodeChange(response);
    } else {
      this.setState({
        hideShowCheckAvailability: false
      });
    }
  };

  hideShowCheckAvailability = () => {
    this.setState({
      hideShowCheckAvailability: true
    });
  };

  render() {
    const {
      itemId,
      zipCode,
      price,
      quantity
    } = this.props;

    const { hideShowCheckAvailability } = this.state;

    const classes = classNames({
      change_zipcode_inner: true,
      u__clearfix: true,
      active: hideShowCheckAvailability
    });
    return (
      <>
        <div className="header-title">
          Delivery options for {zipCode}
        </div>
        <div className="deta_changezip_outer">
          <div className="change_zipcode_Link u__default-link">
            <Button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                this.hideShowCheckAvailability();
                track('click', {
                  origin: 'delivery-options',
                  eventName: 'check fulfillment availability',
                  primaryCategory: 'button submission'
                });
              }}
              link
            >
              Change Delivery Zip Code
            </Button>
          </div>
          <div className={classes}>
            <CheckAvailability
              itemId={itemId.toString()}
              price={parseInt((price * quantity).toFixed(2), 10)}
              zipCode={zipCode}
              onSubmitForm={this.setStateAndProcessResponse}
              quantity={quantity}
            />
          </div>
        </div>
      </>
    );
  }
}

Header.propTypes = {
  itemId: PropTypes.string.isRequired,
  onZipCodeChange: PropTypes.func,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  zipCode: PropTypes.string.isRequired
};

Header.defaultProps = {
  onZipCodeChange: null,
  quantity: 1
};

export default Header;
